import constants from './constants';

const { SET_ENROLLMENTS_BEGIN, SET_ENROLLMENTS_SUCCESS, SET_ENROLLMENTS_ERROR, SET_DEFAULT_DEMOGRAPHIC_FIELD,SET_ENROLLMENTS_CLEANUP, UPDATE_DEMOGRAPHIC_FIELD } = constants;
export const initialState = {
    enrollmentsDetails: {state : '', city: '', zipCode: '', formattedAddress: ''},
    loading: false,
    error: null,
    readableEnrollmentsDetails: null,
};

export const enrollmentsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_ENROLLMENTS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case SET_ENROLLMENTS_SUCCESS:
            return {
                ...state,
                enrollmentsDetails: payload.data,
                loading: false,
                readableEnrollmentsDetails: payload.data
            };

        case SET_ENROLLMENTS_ERROR:
            return {
                ...state,
                enrollmentsDetails: {},
                readableEnrollmentsDetails:{},
                loading: false,
                error: payload.error
            };

        case SET_ENROLLMENTS_CLEANUP:
            return initialState;
        case UPDATE_DEMOGRAPHIC_FIELD: return {
            ...state, enrollmentsDetails: {
                ...state.enrollmentsDetails, [payload.name]: payload.value
            }
        };
        case SET_DEFAULT_DEMOGRAPHIC_FIELD: return {
            ...state, enrollmentsDetails : payload
        };
        default:
            return state;
    }
};